<div
    class="datiq-screen-error"
>
    <div
        class="datiq-screen-error__container datiq-screen-error__container--content"
    >
        <div
            class="datiq-screen-error__container datiq-screen-error__container--icon"
        >
            <mat-icon
                class="datiq-screen-error__icon"
                svgIcon="app:empty_box"

            ></mat-icon>
        </div>
        <div
            class="datiq-screen-error__container datiq-screen-error__container--message"
        >
            <h1 class="datiq-screen-error__title">
                <ng-content
                    select="[datiq-screen-error-message-title]"
                ></ng-content>
            </h1>
            <section class="datiq-screen-error__content">
                <ng-content
                    select="[datiq-screen-error-message-content]"
                ></ng-content>
            </section>
        </div>
    </div>
</div>
